const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const DISCLAIMER =
  "These teas are crafted for wellness, ritual, and herbal support and are not intended to replace medical care or advice from a licensed healthcare provider. If you are pregnant, nursing, taking medications, or under a healthcare provider's care, please consult your provider before use.";

const authHeader = () => {
  const t = localStorage.getItem("ssw_admin_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

async function request(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json", ...(auth ? authHeader() : {}) };
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body != null ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    const err = new Error(`Request failed: ${res.status}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

const qs = (params) => {
  const s = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== "")
  ).toString();
  return s ? `?${s}` : "";
};

// ---- Public ----
export const fetchCollections = () => request("/collections");
export const fetchPricing = () => request("/pricing/loose-leaf");
export const fetchProducts = (params = {}) => request(`/products${qs(params)}`);
export const fetchProduct = (slug) => request(`/products/${slug}`);
export const subscribeNewsletter = (email) => request("/newsletter", { method: "POST", body: { email } });
export const sendContact = (payload) => request("/contact", { method: "POST", body: payload });

// ---- Checkout ----
export const createCheckout = (items, origin_url) =>
  request("/payments/checkout", { method: "POST", body: { items, origin_url } });
export const getPaymentStatus = (sessionId) => request(`/payments/status/${sessionId}`);

// ---- Auth + Admin ----
export const adminLogin = (email, password) =>
  request("/auth/login", { method: "POST", body: { email, password } });
export const adminMe = () => request("/auth/me", { auth: true });
export const adminCreateProduct = (payload) =>
  request("/admin/products", { method: "POST", body: payload, auth: true });
export const adminUpdateProduct = (slug, payload) =>
  request(`/admin/products/${slug}`, { method: "PUT", body: payload, auth: true });
export const adminDeleteProduct = (slug) =>
  request(`/admin/products/${slug}`, { method: "DELETE", auth: true });

export const fetchSiteImages = () => request("/site-images");

export const fetchOrders = () => request("/admin/orders", { auth: true });
export const fulfillOrder = (sessionId) =>
  request(`/admin/orders/${sessionId}/fulfill`, { method: "PUT", auth: true });

export const adminUploadImage = async (slug, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/admin/images/${slug}`, {
    method: "POST",
    headers: { ...authHeader() },
    body: fd,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error("Upload failed");
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
